/**
 * Device Storage API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Schedule } from './schedule';
import { ParameterData } from './parameterData';
import { DeviceCommand } from './deviceCommand';
import { VirtualFenceConstructionRule } from './virtualFenceConstructionRule';


export interface CommandDto { 
    adminCreator?: boolean;
    appliedOnDeviceDB?: boolean;
    appliedOnDeviceTime?: string;
    commandState?: CommandDto.CommandStateEnum;
    configDataStatus?: boolean;
    createdBy?: number;
    dataUploadSource?: CommandDto.DataUploadSourceEnum;
    deviceClassWithOwnIdPool?: CommandDto.DeviceClassWithOwnIdPoolEnum;
    deviceCommand?: DeviceCommand;
    deviceResponses?: Array<CommandDto.DeviceResponsesEnum>;
    gpsPlusRemoteCommand?: boolean;
    idCommand?: string;
    idDevice?: number;
    ignoreFailedCommandStateWhenCounting?: boolean;
    initialCommand?: boolean;
    insertTs?: string;
    isHiddenForCustomers?: boolean;
    originCode?: CommandDto.OriginCodeEnum;
    parameterDataList?: Array<ParameterData>;
    perDeviceRemoteCommandIdentifier?: number;
    readoutCommand?: boolean;
    receivedResponseTime?: string;
    remoteLastSendAttempt?: string;
    remoteRawDataByteLength?: number;
    remoteReceiveFromDeviceRawMessageId?: number;
    remoteSendAttempts?: number;
    remoteSentRawDataHexString?: string;
    schedules?: Array<Schedule>;
    sendToDeviceTime?: string;
    virtualFenceConstructionRules?: Array<VirtualFenceConstructionRule>;
    wildlifeEventCommand?: boolean;
}
export namespace CommandDto {
    export const CommandStateEnum = {
        Created: 'CREATED',
        SentToServer: 'SENT_TO_SERVER',
        SentToDevice: 'SENT_TO_DEVICE',
        FailedSendingToServer: 'FAILED_SENDING_TO_SERVER',
        FailedSendingToDevice: 'FAILED_SENDING_TO_DEVICE',
        FailedOnDevice: 'FAILED_ON_DEVICE',
        FailedUnspecified: 'FAILED_UNSPECIFIED',
        Acknowledged: 'ACKNOWLEDGED',
        Canceled: 'CANCELED',
        FailedExpired: 'FAILED_EXPIRED'
    } as const;
    export type CommandStateEnum = typeof CommandStateEnum[keyof typeof CommandStateEnum];
    export const DataUploadSourceEnum = {
        Provider: 'PROVIDER',
        Gdx: 'GDX',
        HttpUpload: 'HTTP_UPLOAD'
    } as const;
    export type DataUploadSourceEnum = typeof DataUploadSourceEnum[keyof typeof DataUploadSourceEnum];
    export const DeviceClassWithOwnIdPoolEnum = {
        Collar: 'COLLAR',
        ExternalSensor: 'EXTERNAL_SENSOR',
        Camera: 'CAMERA',
        Tt4Sensor: 'TT4_SENSOR',
        ConfigurationDevice: 'CONFIGURATION_DEVICE',
        DropOff: 'DROP_OFF',
        TrapTransmitter: 'TRAP_TRANSMITTER',
        DataLogger: 'DATA_LOGGER'
    } as const;
    export type DeviceClassWithOwnIdPoolEnum = typeof DeviceClassWithOwnIdPoolEnum[keyof typeof DeviceClassWithOwnIdPoolEnum];
    export const DeviceResponsesEnum = {
        Ok: 'OK',
        VasInvalidParameter: 'VAS_INVALID_PARAMETER',
        CrcError: 'CRC_ERROR',
        SubpaketInvalid: 'SUBPAKET_INVALID',
        SubpaketNotSupported: 'SUBPAKET_NOT_SUPPORTED'
    } as const;
    export type DeviceResponsesEnum = typeof DeviceResponsesEnum[keyof typeof DeviceResponsesEnum];
    export const OriginCodeEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodeEnum = typeof OriginCodeEnum[keyof typeof OriginCodeEnum];
}


export type CommandStateEnum = typeof CommandDto.CommandStateEnum[keyof typeof CommandDto.CommandStateEnum];
export type DataUploadSourceEnum = typeof CommandDto.DataUploadSourceEnum[keyof typeof CommandDto.DataUploadSourceEnum];
export type DeviceClassWithOwnIdPoolEnum = typeof CommandDto.DeviceClassWithOwnIdPoolEnum[keyof typeof CommandDto.DeviceClassWithOwnIdPoolEnum];
export type DeviceResponsesEnum = typeof CommandDto.DeviceResponsesEnum[keyof typeof CommandDto.DeviceResponsesEnum];
export type OriginCodeEnum = typeof CommandDto.OriginCodeEnum[keyof typeof CommandDto.OriginCodeEnum];
